<template>
  <div>
    <d-form-row class="form-group">
      <d-col cols="12" v-if="model.data.arrows">
        <label>Setas:</label>
        <div class="d-flex flex-column flex-md-row">
          <div class="d-flex input_arrow">
            <input type="checkbox" v-model="model.data.arrows.right" />
            <img
              src="@/assets/images/arrow.jpeg"
              alt="Arrow Right"
              class="arrows right"
            />
          </div>
          <div class="d-flex input_arrow">
            <input type="checkbox" v-model="model.data.arrows.bottom" />
            <img
              src="@/assets/images/arrow.jpeg"
              alt="Arrow Bottom"
              class="arrows bottom"
            />
          </div>
          <div class="d-flex input_arrow">
            <input type="checkbox" v-model="model.data.arrows.top" />
            <img
              src="@/assets/images/arrow.jpeg"
              alt="Arrow Top"
              class="arrows top"
            />
          </div>
          <div class="d-flex input_arrow">
            <input type="checkbox" v-model="model.data.arrows.left" />
            <img
              src="@/assets/images/arrow.jpeg"
              alt="Arrow Left"
              class="arrows left"
            />
          </div>
          <div class="d-flex input_arrow">
            <input type="checkbox" v-model="model.data.arrows.top_left" />
            <img
              src="@/assets/images/arrow.jpeg"
              alt="Arrow Top Left"
              class="arrows top_left"
            />
          </div>
          <div class="d-flex input_arrow">
            <input type="checkbox" v-model="model.data.arrows.top_right" />
            <img
              src="@/assets/images/arrow.jpeg"
              alt="Arrow Top Right"
              class="arrows top_right"
            />
          </div>
          <div class="d-flex input_arrow">
            <input type="checkbox" v-model="model.data.arrows.bottom_left" />
            <img
              src="@/assets/images/arrow.jpeg"
              alt="Arrow Bottom Left"
              class="arrows bottom_left"
            />
          </div>
          <div class="d-flex input_arrow">
            <input type="checkbox" v-model="model.data.arrows.bottom_right" />
            <img
              src="@/assets/images/arrow.jpeg"
              alt="Arrow Bottom Right"
              class="arrows bottom_right"
            />
          </div>
        </div>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group">
      <d-col cols="12">
        <label>Texto/Palavras:</label>
        <textarea
          class="form-control"
          v-model="model.data.words"
          rows="5"
        ></textarea>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group">
      <d-col cols="12" class="mb-3">
        <label>Grid:</label>
        <textarea
          class="form-control"
          v-model="model.data.grid"
          rows="10"
        ></textarea>
      </d-col>
    </d-form-row>
  </div>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';

import { MODEL, _LOAD_MODEL_, _PUZZLE_CHOOSE_LEVEL_ } from '../PuzzleModel';

const data = {
  grid: '',
  words: '',
  arrows: {
    left: false,
    right: false,
    top: false,
    bottom: false,
    top_left: false,
    top_right: false,
    bottom_left: false,
    bottom_right: false,
  },
};
const PUZZLE = { ...MODEL, ...{ data } };

export default {
  name: 'Hunting-words-puzzle',
  props: {
    model: {
      type: Object,
      require: true,
      default: () => cloneDeep(PUZZLE),
    },
  },
  methods: {
    chooseLevel(param) {
      this.model.data.arrows.right = true;
      this.model.data.arrows.bottom = true;
      if (param === 2) { // Medio
        this.model.data.arrows.left = true;
        this.model.data.arrows.top = true;
      } else if (param === 3) { // Hard
        this.model.data.arrows.top_left = true;
        this.model.data.arrows.top_right = true;
        this.model.data.arrows.bottom_left = true;
        this.model.data.arrows.bottom_right = true;
      }
    },
    initData() {
      if (!this.model.data.arrows) {
        this.model.data = cloneDeep(data);
      }
    },
  },
  mounted() {
    this.initData();
    Events.$on(_LOAD_MODEL_, () => {
      if (this.model.type_id === 1) {
        this.initData();
      }
    });
    Events.$on(_PUZZLE_CHOOSE_LEVEL_, param => {
      this.model.data.arrows = cloneDeep(data.arrows);
      this.chooseLevel(param);
    });
  },
};
</script>

<style lang="scss" scoped>
.input_arrow {
  width: 50px;
  justify-content: space-between;
  align-items: center;
  margin-right: 15px;
}
.arrows {
  &.top {
    transform: rotate(180deg);
  }
  &.right {
    transform: rotate(-90deg);
  }
  &.bottom {

  }
  &.left {
    transform: rotate(90deg);
  }
  &.top_left {
    transform: rotate(130deg);
  }
  &.top_right {
    transform: rotate(-130deg);
  }
  &.bottom_left {
    transform: rotate(45deg);
  }
  &.bottom_right {
    transform: rotate(-45deg);
  }
}
</style>
